import config from '../config'
import { debug } from '../utilities/logger'
import { injectScript } from '../utilities/window'

(function () {
  if (!config['vendors-activated']) {
    return debug(`[vendors][AVAE] Deactivated cause not in production`)
  }
  /**
   * Avis vérifiés
   */
  const meta = document.createElement('meta')
  meta.classList = ['netreviewsWidget']
  meta.id = 'netreviewsWidgetNum16763'
  meta.setAttribute('data-jsurl', '//cl.avis-verifies.com/fr/cache/8/b/0/8b0314b2-9afa-8584-9984-f74d2f42b8ea/widget4/widget10-right-16763_script.js')
  const head = document.getElementsByTagName('head')[0]
  head.appendChild(meta)
  injectScript({ url: '//cl.avis-verifies.com/fr/widget4/widget10_FB3.min.js', isAsync: true })
})()



// WEBPACK FOOTER //
// ./src/vendors/AVAE.js